type MaterialIconProps = {
  name: string
  size?: number | string
  className?: string
  title?: string
  style?: 'outlined' | 'rounded' | 'sharp' | 'filled'
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900
  fill?: 0 | 1
  grade?: -25 | 0 | 25 | 50 | 75 | 100
  opticalSize?: number
}

export function MaterialIcon({
  name,
  size,
  className,
  title,
  style = 'outlined',
  weight = 400,
  fill = 0,
  grade = 0,
  opticalSize = 24,
}: Readonly<MaterialIconProps>) {
  const symbolClass = `material-symbols-${style}`
  const fontVariationSettings = `"FILL" ${fill}, "wght" ${weight}, "GRAD" ${grade}, "opsz" ${opticalSize}`
  const accessibleTitle = title?.trim()

  return (
    <span
      className={[symbolClass, className].filter(Boolean).join(' ')}
      style={
        {
          fontSize: size,
          fontVariationSettings,
          lineHeight: 1,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        } as React.CSSProperties
      }
      aria-label={accessibleTitle ?? name}
      aria-hidden={accessibleTitle ? undefined : true}
      {...(accessibleTitle ? { title: accessibleTitle } : {})}
    >
      {name}
    </span>
  )
}

